import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { DockListEnableItem, DockListInitialState, DockListLoad } from './dock-list.actions';
import { DockListState, DockListStateModel } from './dock-list.state';
import { DockListSearchCriteria } from '../models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';
import { take } from 'rxjs/operators';
import { HubItemFacade } from '../../hub/item';
import { CompartmentItemFacade } from '../../compartment/item';

@Injectable({ providedIn: 'root' })
export class DockListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<DockListStateModel> = this.store.select(DockListState.getState);
  loaded$: Observable<boolean> = this.store.select(DockListState.getLoaded);

  constructor(
    private store: Store,
    private compartmentItemFacade: CompartmentItemFacade,
    private hubItemFacade: HubItemFacade,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
  ) {}

  loadAll(): void {
    combineLatest([
      this.compartmentItemFacade.compartmentId$,
      this.hubItemFacade.hubId$,
      this.listSearchCriteriaFacade.getSearchCriteriaByListType(ListSearchCriteriaType.Docks),
    ])
      .pipe(take(1))
      .subscribe(([compartmentId, hubId, searchCriteria]: [number, number, DockListSearchCriteria]) => {
        this.store.dispatch(new DockListLoad({ compartmentId, hubId, searchCriteria }));
      });
  }

  enableDock(dockId: number, enable: boolean): void {
    combineLatest([this.hubItemFacade.hubId$, this.compartmentItemFacade.compartmentId$])
      .pipe(take(1))
      .subscribe(([hubId, compartmentId]: [number, number]) =>
        this.store.dispatch(
          new DockListEnableItem({
            hubId,
            compartmentId,
            dockId,
            enable,
          }),
        ),
      );
  }

  setInitialState(): void {
    this.store.dispatch(new DockListInitialState());
  }
}
